import React, { useMemo } from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { MOBILE_LENGTH_BY_CODE } from './phoneConfig';

const PhoneInput = ({
  codeName,
  numberName,
  codeValue,
  numberValue,
  onChange,
  countryCodes,
  label = 'Mobile Number',
  required = true,
}) => {
  const expectedLength = useMemo(
    () => MOBILE_LENGTH_BY_CODE[codeValue] || 10,
    [codeValue]
  );

  localStorage.setItem('expectedLength', expectedLength);

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <FormControl sx={{ width: 130 }} required={required}>
        <InputLabel>Code</InputLabel>
        <Select
          label="Code"
          name={codeName}
          value={codeValue}
          onChange={onChange}
        >
          {countryCodes.map(c => (
            <MenuItem key={c.code} value={c.code}>
              {c.label} ({c.code})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label={label}
        name={numberName}
        value={numberValue}
        onChange={onChange}
        required={required}
        fullWidth
        inputProps={{
          inputMode: 'numeric',
          maxLength: expectedLength,
          pattern: `^[0-9]{${expectedLength}}$`,
        }}
        helperText={`${expectedLength} digits required`}
        onInvalid={(e) =>
          e.target.setCustomValidity(
            `Please enter a ${expectedLength}-digit mobile number`
          )
        }
        onInput={(e) => e.target.setCustomValidity('')}
      />
      
    </Box>
  );
};

export default PhoneInput;
